var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "+_vm._s(_vm.content)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }